import React from 'react';

export const Error = ({ className }: { className?: string }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="9" transform="rotate(180 9 9)" fill="currentColor" />
    <rect
      x="10.125"
      y="10.6875"
      width="2.25"
      height="7.875"
      rx="1.125"
      transform="rotate(180 10.125 10.6875)"
      fill="white"
    />
    <rect
      x="10.125"
      y="14.0625"
      width="2.25"
      height="2.25"
      rx="1.125"
      transform="rotate(180 10.125 14.0625)"
      fill="white"
    />
  </svg>
);
